import { trapFocus, removeTrapFocus } from './utils.js';

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.header = document.querySelector('#shopify-section-header');
    this.countdownTimer = document.querySelector('.section-countdown-timer');
    this.announcementBar = document.querySelector('.section-announcement-bar');
    this.headerSearchPanel = document.querySelector('.search-modal__content');

    this.detailsContainer.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[data-close-header-search]').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[data-close-header-search]').addEventListener(
      'keydown',
      e => {
        if (e.key === ' ' || e.key === 'Enter') {
          this.close.bind(this);
        }
      }
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('overlay-open')
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    /* show overlay */
    document.body.classList.add('overflow-hidden', 'overlay-open');
    /* check for sticky header on scroll up */
    if (this.header.classList.contains('shopify-section-header-sticky')) {
      this.headerSearchPanel.style.top = 0 + 'px';
    } else {
      /* check if the countdown timer and annoucnement bar are visible */
      this.headerSearchPanel.style.top =
        this.countdownTimer.offsetHeight +
        this.announcementBar.offsetHeight +
        'px';
    }
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('.ais-SearchBox-input')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    /* hide overlay */
    document.body.classList.remove('overflow-hidden', 'overlay-open');
  }
}

customElements.define('details-modal', DetailsModal);
